import { BehaviorSubject, Observable, of } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { switchMap, catchError } from 'rxjs/operators';

const initialState: TimApp.ApiConfiguration = {
  flags: [],
  baseUrl: '',
  error: false,
  tfsUrl: '',
};

export class AppStore {
  private getApiPath: TimApp.AppPathFunc;

  private readonly subject = new BehaviorSubject(initialState);

  constructor(getApiPath: TimApp.AppPathFunc) {
    this.getApiPath = getApiPath;
  }

  init(): AppStore {
    fromFetch(this.getApiPath(''))
      .pipe(
        switchMap((res) => {
          if (res.ok) {
            return res.json();
          }
          return of({ error: true, message: `Error ${res.status}` });
        }),
        catchError((err) => {
          console.error(err);
          return of({ error: true, message: err.message });
        })
      )
      .subscribe({
        next: (result) => {
          const newState = {
            ...this.subject.getValue(),
            flags: result.flags,
            baseUrl: result.baseUrl,
            error: result?.error,
            tfsUrl: result?.tfsUrl,
          };
          this.subject.next(newState);
        },
      });

    return this;
  }

  get observable(): Observable<TimApp.ApiConfiguration> {
    return this.subject.asObservable();
  }

  get value(): TimApp.ApiConfiguration {
    return this.subject.getValue();
  }
}
